import { darken } from 'polished'

import colors from './colors'

export default {
  backgroundColor: {
    white: colors.white,
    default: colors.primary,
    secondary: colors.secondary,
  },
  backgroundColorHover: {
    white: darken(0.05, colors.white),
    default: darken(0.02, colors.primary),
    secondary: darken(0.02, colors.secondary),
  },
  backgroundColorActive: {
    white: darken(0.1, colors.white),
    default: darken(0.04, colors.primary),
    secondary: darken(0.04, colors.secondary),
  },
  color: {
    white: colors.primary,
    default: colors.white,
  },
  borderColor: {
    white: colors.white,
    default: colors.primary,
    secondary: colors.secondary,
  },
  disabled: {
    secondary: colors.silverChalice,
    primary: colors.silverChalice,
    default: colors.silverChalice,
  },
  outline: {
    color: {
      white: colors.white,
      secondary: colors.primary,
      default: colors.primary,
    },
    active: {
      white: `${colors.white}80`,
      secondary: colors.secondary,
      default: colors.primary,
    },
    hover: {
      white: `${colors.white}C8`,
      secondary: colors.primary,
      default: colors.primary,
    },
    disabled: {
      secondary: colors.secondary,
      default: colors.primary,
    },
  },
  blueprint: {
    backgroundColor: {
      default: colors.actionBlue,
    },
    color: {
      default: colors.white,
    },
    backgroundColorHover: {
      default: colors.ultramarine,
    },
    backgroundColorActive: {
      default: darken(0.01, colors.actionBlue),
    },
    backgroundColorDisabled: {
      default: colors.silverChalice,
    },
    borderColor: {
      default: colors.primary,
    },
  },
}
